import request from '@/utils/request'
let OrderApi = {
  /*订单列表*/
  orderlist(data, errorback) {
    return request._post('/merch/order.order/index', data, errorback);
  },
  /*订单详情*/
  orderdetail(data, errorback) {
    return request._post('/merch/order.order/detail', data, errorback);
  },
  /*售后管理*/
  orderrefund(data, errorback) {
    return request._post('/merch/order.refund/index', data, errorback);
  },
  /*去发货*/
  delivery(data, errorback) {
    return request._post('/merch/order.order/delivery', data, errorback);
  },
  /*确认审核*/
  confirm(data, errorback) {
    return request._post('/merch/order.Operate/confirmCancel', data, errorback);
  },
  /*售后详情*/
  refundDetail(data, errorback) {
    return request._get('/merch/order.refund/detail', data, errorback);
  },
  /*售后审核*/
  Approval(data, errorback) {
    return request._get('/merch/order.refund/audit', data, errorback);
  },
  /*确认收货并退款*/
  receipt(data, errorback) {
    return request._post('/merch/order.refund/receipt', data, errorback);
  },
  /*核销*/
  extract(data, errorback) {
    return request._post('/merch/order.operate/extract', data, errorback);
  },
  /*修改价格*/
  updatePrice(data, errorback) {
    return request._post('/merch/order.order/updatePrice', data, errorback);
  },
  /*分销订单*/
  agentOrder(data, errorback) {
    return request._post('/merch/order.agent/index', data, errorback);
  },
  queryLogistics(data, errorback) {
    return request._post('/merch/order.order/express', data, errorback);
  },
  updateAddress(data, errorback) {
    return request._post('/merch/order.order/updateAddress', data, errorback);
  },
  /*批量发货*/
  batchDelivery(formData, errorback) {
    return request._upload('/merch/order.operate/batchDelivery', formData, errorback);
  },
  /*取消订单*/
  orderCancel(formData, errorback) {
    return request._upload('/merch/order.order/orderCancel', formData, errorback);
  },
  /*虚拟商品发货*/
  virtual(formData, errorback) {
    return request._upload('/merch/order.order/virtual', formData, errorback);
  },
  /*小程序发货*/
  wxDelivery(formData, errorback) {
    return request._post('/merch/order.order/wxDelivery', formData, errorback);
  },
}

export default OrderApi;



// WEBPACK FOOTER //
// ./src/api/order.js